import useApi from '@/composables/api/useApi'
import type { IEsgContactForm } from '@/domains/esg/types/form.types'

export default function useEsgContactApi() {
  const { esgApiUrl } = useRuntimeConfig().public
  const { fetchApi } = useApi(esgApiUrl as string ?? '')

  const submitContactForm = async (body: IEsgContactForm) => {
    const formData = new FormData()
    formData.append('firstName', body.firstName || '')
    formData.append('lastName', body.lastName || '')
    formData.append('email', body.email)
    formData.append('messageTitle', body.messageTitle)
    formData.append('messageText', body.messageText)
    if (body.document) {
      formData.append('document', body.document)
    }

    return await fetchApi('/contact', {
      method: 'POST',
      body: formData,
    })
  }

  return { submitContactForm }
}
